import Generic from 'src/models/generic/Generic'
import Model, { ID, Integer, JsonObject } from 'src/models/model'

export const DELIVERY_TYPE_OPTIONS = {
  COLLECT_FROM_REGISTER: 'collect-from-register',
  DIRECT_TO_CUSTOMER: 'direct-to-customer',
  COUNTER_PICKUP: 'counter-pickup',
  REGISTER: 'register',
  CUSTOM: 'custom',
  TABLE: 'table',
  THEATER_SEAT: 'theater-seat',
  VIRTUAL: 'virtual',
  EXPRESS_PICKUP: 'express-pickup'
}

DELIVERY_TYPE_OPTIONS.ALL = _.values(DELIVERY_TYPE_OPTIONS)

DELIVERY_TYPE_OPTIONS.ON_DEMAND = [
  DELIVERY_TYPE_OPTIONS.COLLECT_FROM_REGISTER
]

DELIVERY_TYPE_OPTIONS.SYNCHRONOUS = [
  DELIVERY_TYPE_OPTIONS.DIRECT_TO_CUSTOMER,
  DELIVERY_TYPE_OPTIONS.REGISTER
]

DELIVERY_TYPE_OPTIONS.ASYNCHRONOUS = [
  DELIVERY_TYPE_OPTIONS.COUNTER_PICKUP,
  DELIVERY_TYPE_OPTIONS.CUSTOM,
  DELIVERY_TYPE_OPTIONS.EXPRESS_PICKUP,
  DELIVERY_TYPE_OPTIONS.TABLE,
  DELIVERY_TYPE_OPTIONS.THEATER_SEAT
]

DELIVERY_TYPE_OPTIONS.KITCHEN = [
  DELIVERY_TYPE_OPTIONS.COUNTER_PICKUP,
  DELIVERY_TYPE_OPTIONS.EXPRESS_PICKUP,
  DELIVERY_TYPE_OPTIONS.REGISTER,
  DELIVERY_TYPE_OPTIONS.TABLE,
  DELIVERY_TYPE_OPTIONS.THEATER_SEAT
]

DELIVERY_TYPE_OPTIONS.DELIVERY_LOCATION_REQUIRED = [
  DELIVERY_TYPE_OPTIONS.TABLE,
  DELIVERY_TYPE_OPTIONS.THEATER_SEAT
]

DELIVERY_TYPE_OPTIONS.COMPLEXITY_ASCENDING = [
  DELIVERY_TYPE_OPTIONS.COLLECT_FROM_REGISTER,
  DELIVERY_TYPE_OPTIONS.DIRECT_TO_CUSTOMER,
  DELIVERY_TYPE_OPTIONS.REGISTER,
  DELIVERY_TYPE_OPTIONS.COUNTER_PICKUP,
  DELIVERY_TYPE_OPTIONS.EXPRESS_PICKUP,
  DELIVERY_TYPE_OPTIONS.CUSTOM,
  DELIVERY_TYPE_OPTIONS.THEATER_SEAT,
  DELIVERY_TYPE_OPTIONS.TABLE
]

DELIVERY_TYPE_OPTIONS.RESTRICTABLE = [
  DELIVERY_TYPE_OPTIONS.COUNTER_PICKUP,
  DELIVERY_TYPE_OPTIONS.THEATER_SEAT,
  DELIVERY_TYPE_OPTIONS.TABLE
]

Object.freeze(DELIVERY_TYPE_OPTIONS)

export default class DeliveryType extends Model {
  static name = 'DeliveryType'

  static isConfiguration = true

  static deletable = false

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Kitchen, Model.permissionCategories.PointOfSale]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null
      },
      description: {
        type: String,
        default: ''
      },
      enable: {
        type: Boolean,
        default: true
      },
      availableOnline: {
        type: Boolean,
        default: false
      },
      hasDetails: {
        type: Boolean,
        default: false
      },
      requireDetails: {
        type: Boolean,
        default: false
      },
      detailsMessage: {
        type: String,
        default: ''
      },
      detailsFieldName: {
        type: String,
        default: ''
      },
      displayOrder: {
        type: Integer,
        default: 100
      }
    }

    this.paginate = true

    this.queries = {
      deliverySummaryWithCache: {
        arguments: {
          cacheKeyByLocations: {
            type: JsonObject,
            required: true
          }
        },
        results: {
          summary: Generic
        }
      }
    }
  }

  get label () {
    return this.name
  }

  get value () {
    return this.id.toString()
  }
}
